export default {
  tipoAvisoProgramadoList: [],
  dateSelected: '',
  avisosProgramados: [],
  avisosAtivos: [],
  avisosExpirados7Dias: [],
  eventSelected: {},
  eventPublicoAlvo: [],
  avisos: []
}
